<app-navigation tagline="WEITERCHECKEN" marginLeftClass="ml-20"></app-navigation>
<ion-content>
  <div class="ion-margin slide">
    <h2>Check abgeschlossen</h2>
    <p>
      Du hast den Check bereits abgeschlossen. Möchtest Du Dein Ergebnis anschauen oder den Check noch einmal neu starten?
    </p>
    <ion-button (click)="continue()"  color="dark" style="color: #fff; margin-top: 1em; width: 16em">
      <ion-icon name="document-text-outline" style="padding-right:10px" ></ion-icon>
      ERGEBNIS ANSCHAUEN
    </ion-button><br>
    <ion-button (click)="startAgain()"  color="dark" style="color: #fff; width: 16em">
      <ion-icon name="rocket-outline" style="padding-right:10px" ></ion-icon>
      CHECK NEU STARTEN
    </ion-button>
  </div>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
